import React from 'react';
import clsx from 'clsx';
import { NavLink as ReactNavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightUpIcon } from 'common-assets/assets/icons/arrow-right-up.svg';
import { ReactComponent as DocumentFilledIcon } from 'common-assets/assets/icons/document-filled.svg';
import { Icon } from '../../Icon/Icon';
import { LinkNavLinkProps } from '../Link.types';
import { translateOne } from 'common-react';

import useStyles from '../Link.style';

export const LinkNavLink: React.FC<LinkNavLinkProps> = ({
  to,
  onClick,
  className,
  ariaLabel,
  testId,
  autoTestId,
  children,
  variant = 'underline',
  showExternalIcon = false,
  showDocumentIcon = false,
  onKeyDown,
  tabIndex,
  disabled,
  size = 'default',
  routeState
}) => {
  const [url] = useTranslation('url');
  const c = useStyles({ variant, disabled, showExternalIcon, showDocumentIcon, size });

  return (
    <ReactNavLink
      to={{
        pathname: translateOne(to, url),
        state: { ...routeState, systemPath: to }
      }}
      onClick={disabled ? undefined : onClick}
      className={clsx(c.root, className)}
      aria-label={ariaLabel}
      aria-disabled={disabled}
      data-testid={testId}
      data-autotestid={autoTestId}
      onKeyDown={disabled ? undefined : onKeyDown}
      tabIndex={disabled ? -1 : tabIndex}
    >
      {(showDocumentIcon || showExternalIcon) ? (
        <>
          {showDocumentIcon && (
            <Icon className={c.documentIcon}>
              <DocumentFilledIcon />
            </Icon>
          )}
          <span className={c.linkText}>
            {children}
            {showExternalIcon && (
              <Icon className={c.icon}>
                <ArrowRightUpIcon />
              </Icon>
            )}
          </span>
        </>
      ) : (
        children
      )}
    </ReactNavLink>
  );
};
